export const get_recent_activities = "get_recent_activities";
